export default __webpack_public_path__ + "static/media/rightQuote.b03cace4.svg";